module.exports = __webpack_public_path__ + "static/media/harsh.aca05dd8.jpg";